export enum SetupStates {
  Welcome,
  Terms,
  OrgSetup,
  UserSync,
  DriverOnboarding,
  Done,
}
